import React from "react"
import type { NoteColor } from "../types"
import { NOTE_COLOR_OPTIONS } from "../utils/noteColors"
import "./NoteColorPicker.style.scss"

interface NoteColorPickerProps {
  value: NoteColor
  onChange: (color: NoteColor) => void
  disabled?: boolean
}

const NoteColorPicker = ({
  value,
  onChange,
  disabled,
}: NoteColorPickerProps) => (
  <fieldset className="note-color-picker" disabled={disabled}>
    <legend>Color Label</legend>
    <div className="note-color-picker__swatches">
      {NOTE_COLOR_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className={`note-color-picker__swatch is-${option.id} ${
            value === option.id ? "is-selected" : ""
          }`}
          aria-label={`Select ${option.label} color`}
          aria-pressed={value === option.id}
          onClick={() => onChange(option.id)}
        />
      ))}
    </div>
  </fieldset>
)

export default NoteColorPicker
